<p>
  Създаването на потребителски профил е първата стъпка към пълноценното използване на платформата – включително
  публикуване на обяви, участие в търгове, покупка на артикули, комуникация между потребители и др. Регистрацията е
  напълно безплатна и отнема само няколко минути.
</p>
<h6 class="mt-3">Как да започнете?</h6>
<p>
  Можете да започнете, като натиснете бутона <strong>„Регистрация“</strong> в горната част на сайта или отворите
  директно страницата за
  <a class="text-decoration-none"
     [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.registration]">
    регистрация.
  </a>
</p>
<h6 class="mt-3">Каква информация се изисква?</h6>
<p class="mb-1">
  В регистрационната форма трябва да въведете следните данни:
</p>
<ul>
  <li><strong>Потребителско име</strong> – ще бъде видимо за останалите потребители;</li>
  <li><strong>Електронна поща</strong> – валиден имейл адрес, необходим за потвърждение на профила;</li>
  <li><strong>Парола</strong> – използвайте силна парола с минимум 8 символа;</li>
  <li><strong>Повторете паролата</strong> – за потвърждение и избягване на грешки;</li>
  <li><strong>Име и фамилия</strong> – служат за коректна идентификация, не се показват публично.</li>
</ul>
<p>
  За да завършите регистрацията, е необходимо да поставите отметка, че приемате
  <a class="text-decoration-none"
     [routerLink]="[appRoutes.root, appRoutes.termsConditions]">
    общите условия
  </a> на платформата.
</p>
<p>
  След изпращане на формуляра ще получите имейл с линк за потвърждение. Натиснете върху линка, за да активирате своя
  профил. Без потвърждение няма да може да влезете или да използвате основните функции.
</p>
<p>
  След като потвърдите успешно, профилът ви става активен и може да започнете да използвате всички възможности на
  платформата.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Ако не откриете писмото за потвърждение в основната поща, проверете папките „Спам“ или
  „Нежелана поща“. При нужда от помощ, свържете се с нас чрез
  <a class="text-decoration-none"
     [routerLink]="[appRoutes.root, appRoutes.contactUs]">
    формата за контакт.
  </a>
</div>
